
      import API from "!../../.yarn/__virtual__/style-loader-virtual-8efe4aa1c3/5/.yarn/berry/cache/style-loader-npm-3.3.3-2e8bbeeac4-10c0.zip/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../.yarn/__virtual__/style-loader-virtual-8efe4aa1c3/5/.yarn/berry/cache/style-loader-npm-3.3.3-2e8bbeeac4-10c0.zip/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../.yarn/__virtual__/style-loader-virtual-8efe4aa1c3/5/.yarn/berry/cache/style-loader-npm-3.3.3-2e8bbeeac4-10c0.zip/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../.yarn/__virtual__/style-loader-virtual-8efe4aa1c3/5/.yarn/berry/cache/style-loader-npm-3.3.3-2e8bbeeac4-10c0.zip/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../.yarn/__virtual__/style-loader-virtual-8efe4aa1c3/5/.yarn/berry/cache/style-loader-npm-3.3.3-2e8bbeeac4-10c0.zip/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../.yarn/__virtual__/style-loader-virtual-8efe4aa1c3/5/.yarn/berry/cache/style-loader-npm-3.3.3-2e8bbeeac4-10c0.zip/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../.yarn/__virtual__/css-loader-virtual-c9bc500a5d/5/.yarn/berry/cache/css-loader-npm-6.8.1-30d84b4cf1-10c0.zip/node_modules/css-loader/dist/cjs.js!./global.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../.yarn/__virtual__/css-loader-virtual-c9bc500a5d/5/.yarn/berry/cache/css-loader-npm-6.8.1-30d84b4cf1-10c0.zip/node_modules/css-loader/dist/cjs.js!./global.css";
       export default content && content.locals ? content.locals : undefined;
